import React from 'react';
import {
  Calendar,
  Trophy,
  HeadphonesIcon,
  BarChart3,
  Users,
  Network
} from 'lucide-react';

const tools = [
  { name: 'Book a desk', icon: Calendar, color: 'bg-gray-600' },
  { name: 'Recognise a colleague', icon: Trophy, color: 'bg-yellow-500' },
  { name: 'ServiceNow', icon: HeadphonesIcon, color: 'bg-green-600' },
  { name: 'Clarity', icon: BarChart3, color: 'bg-blue-500' },
  { name: 'Workday', icon: Users, color: 'bg-orange-500' },
  { name: 'Connect', icon: Network, color: 'bg-purple-500' },
];

export const CorporateTools: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-4">Corporate Tools</h2>
      <div className="grid grid-cols-6 gap-4">
        {tools.map((tool) => {
          const Icon = tool.icon;
          return (
            <button
              key={tool.name}
              className="flex flex-col items-center justify-center p-4 hover:bg-gray-50 rounded-lg transition-colors"
            >
              <div className={`w-12 h-12 ${tool.color} rounded-lg flex items-center justify-center text-white mb-2`}>
                <Icon className="w-6 h-6" />
              </div>
              <span className="text-xs text-gray-700 text-center">{tool.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};